import React, { useState, useRef } from "react";

export default function MarriageProposal() {
  // 내부적으로 버튼이 이동할 '보이지 않는 영역'의 크기
  const MOVE_AREA_WIDTH = 375;
  const MOVE_AREA_HEIGHT = 600;

  const btnWidth = 140;
  const btnHeight = 56;
  const marginFromTop = 120;

  const [showImage, setShowImage] = useState(false);
  // 아니오 버튼 위치, {left, top} (MOVE_AREA 기준)
  const [noButtonPos, setNoButtonPos] = useState({
    left: MOVE_AREA_WIDTH / 2 + 60,
    top: MOVE_AREA_HEIGHT - btnHeight - 60,
  });

  // 아니오 버튼 이동 (항상 MOVE_AREA 내)
  const moveNoButton = () => {
    const maxLeft = MOVE_AREA_WIDTH - btnWidth - 24;
    const maxTop = MOVE_AREA_HEIGHT - btnHeight - marginFromTop - 24;
    const left = Math.max(0, Math.random() * maxLeft);
    const top = Math.max(marginFromTop, Math.random() * maxTop + marginFromTop);
    setNoButtonPos({ left, top });
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "#ff69b4",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* 버튼 이동용 숨은 영역 */}
      <div
        style={{
          width: MOVE_AREA_WIDTH,
          height: MOVE_AREA_HEIGHT,
          position: "relative",
          // 영역 보이지 않게(디버깅 시 아래 줄 주석 해제)
          // border: "1px dashed #fff",
        }}
      >
        <div
          style={{
            color: "white",
            fontSize: "2.1rem",
            fontWeight: "bold",
            marginBottom: "44px",
            textShadow: "0px 2px 10px #c2185b",
            whiteSpace: "nowrap",
            textAlign: "center",
            marginTop: "36px",
          }}
        >
          나랑 결혼해줄래?
        </div>

        {/* 예/아니오 버튼 영역 */}
        {!showImage && (
          <>
            {/* 예 버튼: 항상 하단 고정 */}
            <button
              style={{
                background: "white",
                color: "#ff69b4",
                border: "none",
                borderRadius: "10px",
                fontSize: "1.3rem",
                fontWeight: "bold",
                padding: "16px 38px",
                cursor: "pointer",
                boxShadow: "0px 2px 12px #f8bbd0",
                width: btnWidth,
                height: btnHeight,
                whiteSpace: "nowrap",
                position: "absolute",
                left: MOVE_AREA_WIDTH / 2 - btnWidth - 20,
                top: MOVE_AREA_HEIGHT - btnHeight - 40,
                zIndex: 1,
                transition: "background 0.2s",
              }}
              onClick={() => setShowImage(true)}
            >
              예
            </button>

            {/* 아니오 버튼: 무조건 MOVE_AREA 안에서만 이동 */}
            <button
              style={{
                background: "white",
                color: "#ff69b4",
                border: "none",
                borderRadius: "10px",
                fontSize: "1.3rem",
                fontWeight: "bold",
                padding: "16px 38px",
                cursor: "pointer",
                boxShadow: "0px 2px 12px #f8bbd0",
                width: btnWidth,
                height: btnHeight,
                whiteSpace: "nowrap",
                position: "absolute",
                left: noButtonPos.left,
                top: noButtonPos.top,
                transition: "left 0.4s cubic-bezier(.5,1.6,.4,.7), top 0.4s cubic-bezier(.5,1.6,.4,.7)",
                zIndex: 2,
              }}
              onClick={moveNoButton}
            >
              아니오
            </button>
          </>
        )}

        {/* 예 버튼 클릭 시 이미지 표시 */}
        {showImage && (
          <img
            src={require("../assets/춘배움짤.gif")}
            alt="춘배"
            style={{
              marginTop: "60px",
              width: "90%",
              maxWidth: "350px",
              borderRadius: "24px",
              boxShadow: "0 4px 32px #d81b60",
              border: "4px solid white",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        )}
      </div>
    </div>
  );
}